<template lang="html">
  <div class="container">
    <img src="../assets/img/login_logo.png" alt="" class="logo" v-if="!isFocus">
    <div class="registr"  v-if="type == 1">
      <input type="tel" placeholder="手机号" class="phone" maxlength="11" v-model="tel" @focus="isFocus = true" @blur="isFocus = false">

      <!-- <input type="text" placeholder="验证码" class="code"> -->

      <!-- <span>获取验证码</span> -->
    </div>

    <div class="login" v-else>
      <img src="../assets/img/title.jpg" alt="">
    </div>
    <p class="success" @click="login">{{ type == 1 ? '绑定' : '登录'}}</p>
  </div>

</template>

<script>
import config from '../fetch/config'
export default {
  data () {
    return {
      type: 2,
      isFocus: false,
      tel: null,
      query: {}
    }
  },
  mounted () {
    this.query = this.$route.query
    if (this.query.accessToken) {
      // 获取token 成功
      window.localStorage.setItem('token', this.query.accessToken)

      this.getMyData()
    } else if (this.query.bindId) {
      // 微信绑定手机号
      this.type = 1
    }
  },
  methods: {
    getMyData () {
      console.log('getMyData')
      this.$http.getMyData().then(() => {
        window.location.href = config.homeUrl
      })
    },
    logout () {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userId')
        window.localStorage.removeItem('departmentId')
        this.$router.push({ name: 'login' })
      },
    login () {
      if (this.type == 1) {
        let data = {
          phone: this.tel,
          ...this.query,
        }
        this.$http.bindUser(data).then(res => {
          if (res.errCode == 0) {
            window.localStorage.setItem('token', res.data.accessToken)
            this.getUserInfo()
            this.$notice.tip('绑定成功')
            window.location.href = config.homeUrl
          } else {
            this.$notice.tip('绑定失败,请联系管理员~~')
          }
        })
      } else {
        // 正式
        let redirectUri = config.wxUrl
        var ua = window.navigator.userAgent.toLowerCase();
        if ((ua.match(/MicroMessenger/i) == 'micromessenger') && (ua.match(/wxwork/i) == 'wxwork')) {
          // 企业微信客户端
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww66791c90425dba05&redirect_uri=" + encodeURIComponent(redirectUri) + "&response_type=code&scope=snsapi_userinfo"
          console.log('企业微信客户端')
        } else if (ua.match(/micromessenger/i) == 'micromessenger') {
          // 微信客户端
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5bfc0db80a0f82c6&redirect_uri=" + encodeURIComponent(redirectUri) + "&response_type=code&scope=snsapi_userinfo"
          console.log('微信客户端')
        } else {
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5bfc0db80a0f82c6&redirect_uri=" + encodeURIComponent(redirectUri) + "&response_type=code&scope=snsapi_userinfo"
          console.log('浏览器')
        }


      }
    },
    getUserInfo () {
      this.$http.getUserInfo().then(res => {
        if (res.errCode == 0) {
          window.localStorage.setItem('userId', res.data.id)
        }
      })
    }
  },
}

</script>

<style lang="css" scoped>
.container {
  width: 100%;
  background: url("../assets/img/login.png") no-repeat;
  background-size: 100% auto;
  height: 100%;
}
.success {
  width: 7.25rem;
  color: #fff;
  height: 1.125rem;
  background: linear-gradient(to right, #8d80f1, #87aaf9);
  font-size: 0.5rem;
  line-height: 1.125rem;
  text-align: center;
  margin: auto;
  position: absolute;
  bottom: 1.78125rem;
  right: 0;
  left: 0;
  border-radius: 0.0625rem;
}
.logo {
  width: 2.5625rem;
  height: 2.5625rem;
  position: absolute;
  top: 3.65625rem;
  left: 50%;
  transform: translateX(-50%);
}
.login img {
  width: 4.6875rem;
  position: absolute;
  /*top: 42.254%;*/
  top: 7.65625rem;
  left: 0;
  right: 0;
  margin: auto;
}
.registr {
  width: 7.25rem;
  margin: auto;
  position: absolute;
  bottom: 4.8125rem;
  right: 0;
  left: 0;
}
.phone,
.code {
  border-radius: 0;
  border-bottom: 1px solid #8050f4;
  width: 100%;
  height: 1.125rem;
  font-size: 0.4375rem;
  padding-left: 3%;
  outline: medium;
  background: #fff;
}
.code {
  position: relative;
}
.registr span {
  color: #6498ff;
  border: 1px solid #6498ff;
  font-size: 0.375rem;
  border-radius: 0.1875rem;
  position: absolute;
  bottom: 10%;
  right: 1%;
  outline: medium;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue